<div *ngIf="(pending$ | async) === pendingState.success" class="wrapper">
  <div class="back-link-container">
    <a routerLink="../.." class="back-on-mobile mat-h2 back-link"
      ><mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'NAVBAR.MY_ACCOUNT' | translate }}</a
    >
  </div>
  <div class="edge">
    <div>
      <form (keydown.enter)="$event.preventDefault()">
        <div style="font-size: 16px">
          <mat-form-field class="search-bar">
            <span matPrefix><mat-icon>search</mat-icon> &nbsp;</span>
            <input
              matInput
              [(ngModel)]="searchValue"
              [ngModelOptions]="{ standalone: true }"
              (keyup)="applyFilter()"
              placeholder="{{ 'ORDERS.DASHBOARD.SEARCH_BAR_PLACEHOLDER' | translate }}"
              value=""
            />
          </mat-form-field>
        </div>
      </form>
    </div>
    <!--        <div>-->
    <!--          <mat-form-field style="padding-right: 1rem">-->
    <!--            <mat-label>Status</mat-label>-->
    <!--            <mat-select [(value)]="selectedStatus" (selectionChange)="applyFilter()">-->
    <!--              <mat-option>Alle</mat-option>-->
    <!--              <mat-option value="ACTIVE">Aktiv</mat-option>-->
    <!--              <mat-option value="CANCELED">Gekündigt</mat-option>-->
    <!--              <mat-option value="ORDERED">Bestellt</mat-option>-->
    <!--              <mat-option value="INACTIVE">Inaktiv</mat-option>-->
    <!--            </mat-select>-->
    <!--          </mat-form-field>-->
    <!--          <mat-form-field>-->
    <!--            <mat-label>Bestelldatum</mat-label>-->
    <!--            <mat-select [(value)]="selectedOrderDate" (selectionChange)="applyFilter()">-->
    <!--              <mat-option>Alle</mat-option>-->
    <!--              <mat-option value="last3Months">Letzte 3 Monate</mat-option>-->
    <!--              <mat-option value="last6Months">Letzte 6 Monate</mat-option>-->
    <!--              <mat-option value="last12Months">Letzte 12 Monate</mat-option>-->
    <!--            </mat-select>-->
    <!--          </mat-form-field>-->
    <!--        </div>-->
  </div>
  <cover-orders-list *ngIf="!showTable" [dataSource]="dataSource"></cover-orders-list>
  <cover-orders-table
    *ngIf="showTable"
    [dataSourceSubscr]="dataSourceSubscr"
    [dataSourceArt]="dataSourceArt"
  ></cover-orders-table>
</div>
<div class="spinner spinner-margin-top spinner-margin-bottom" *ngIf="(pending$ | async) === pendingState.pending">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="(pending$ | async) === pendingState.failed" class="wrapper">
  <mat-card class="confinement">
    <mat-card-title class="error-text">
      {{ 'ERROR.TITLE' | translate }}
    </mat-card-title>
    <mat-card-content class="error-text">
      {{ 'ERROR.DESCRIPTION' | translate }}
    </mat-card-content>
  </mat-card>
</div>
